export const SMALL_LAYOUT_PAYMENTS_POPUP_WIDTH = 380;
export const SMALL_LAYOUT_PAYMENTS_POPUP_HEIGHT = 450;
export const SMALL_LAYOUT_ONLINE_PAYMENTS_POPUP_HEIGHT = 371;
export const SMALL_LAYOUT_WIDTH_PERCENT = 0.7;
